"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.post = exports.get = void 0;
var config_1 = require("../config");
var request = function (path, _a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.headers, headers = _b === void 0 ? {} : _b, rest = __rest(_a, ["headers"]);
    var fullUrl = "" + config_1.default._apiPath + path;
    var requestHeaders = __assign({ 'X-Client-Id': config_1.default._clientId, 'X-Client-Version': config_1.default._clientVersion.toString(), 'Content-Type': 'application/json' }, headers);
    return fetch(fullUrl, __assign(__assign({}, rest), { headers: requestHeaders })).then(function (res) { return res.json(); });
};
exports.get = request;
var post = function (path, _a) {
    var _b = _a.headers, headers = _b === void 0 ? {} : _b, _c = _a.body, body = _c === void 0 ? {} : _c, rest = __rest(_a, ["headers", "body"]);
    return request(path, __assign(__assign({}, rest), { headers: headers, method: 'POST', body: JSON.stringify(body) }));
};
exports.post = post;
